// Default environment configuration for development
export const environment = {
  production: false,
  env: 'dev',
  name: 'DreamPay',
  appId: 'dreampay-shared',
  apiURL: 'https://dev-private-api.dreampay.com.br',
};
